import { first, get, isArray } from 'lodash'
import React, { ReactNode } from 'react'

export type TFeedbackRender = ReactNode | Error | boolean

const FeedbackRender = (props: {
  feedback: TFeedbackRender
}): React.ReactElement | null => {
  const { feedback } = props

  if (!feedback) {
    return null
  }

  return (
    <>
      {feedback &&
        !get(feedback, 'props') &&
        String(
          get(
            isArray(feedback) ? first(feedback) : feedback,
            'error',
            feedback,
          ),
        )}
      {feedback && get(feedback, 'props') && get(feedback, 'props.children')}
    </>
  )
}

export default FeedbackRender
